import React from "react";
import s from "./style.module.css";

const getTextSpans = (value, breakLine, x, y, anchor) => {
  const items = value.split("\u000b");

  return items.map((d, i) => (
    <tspan
      dy={i * 16 - (items.length - 1) * 8}
      x={x}
      y={y}
      text-anchor={anchor}
    >
      {d}
    </tspan>
  ));
};

const ClusterViz = ({ text }) => {
  return (
    <div className={s.wrap}>
      <div className={s.rotate}>
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 300 300"
          enable-background="new 0 0 300 300"
        >
          <g id="BG">
            <circle
              fill="#EE6047"
              stroke="#DE2414"
              stroke-miterlimit="10"
              cx="150"
              cy="150"
              r="150"
            />
          </g>
          <g id="Strategic_plannig">
            <g>
              <path
                id="p_528.3126953742086"
                fill="#FCC0B4"
                stroke="#DE2414"
                stroke-miterlimit="10"
                d="M210,63c-0.1,33.1-27,60.1-60.1,60.2
        			S89.9,96.4,90,63.3c0,0,0,0,0,0c0.1-33.1,27-60.1,60.1-60.2C183.3,3,210.1,29.8,210,63C210,62.9,210,63,210,63z"
              />
              <g>
                <g id="p_611.8585410466832_7_">
                  <path
                    fill="#FFFFFF"
                    d="M196.5,83.6c0,15.3-12.5,27.8-27.8,27.8S140.9,99.1,141,83.7c0,0,0,0,0,0c0-15.3,12.5-27.8,27.8-27.8
        					C184.1,55.9,196.5,68.2,196.5,83.6C196.5,83.6,196.5,83.6,196.5,83.6z"
                  />
                </g>
                <g id="p_881.674016733653_32_">
                  <path
                    fill="#FCDFDA"
                    d="M157,44.1c0,15.3-12.5,27.8-27.8,27.8s-27.7-12.4-27.7-27.7c0,0,0,0,0,0c0-15.3,12.5-27.8,27.8-27.8
        					S157.1,28.8,157,44.1C157,44.1,157,44.1,157,44.1z"
                  />
                </g>
                <g id="p_881.674016733653_30_">
                  <path
                    fill="#FCDFDA"
                    d="M138.6,85.9c0,6.7-5.5,12.2-12.2,12.2c-6.7,0-12.2-5.4-12.2-12.2c0,0,0,0,0,0c0-6.7,5.5-12.2,12.2-12.2
        					C133.2,73.7,138.7,79.2,138.6,85.9C138.6,85.9,138.6,85.9,138.6,85.9z"
                  />
                </g>
                <path
                  id="p_881.674016733653_28_"
                  fill="#F8A08F"
                  d="M115.5,73.8c0,4.7-3.8,8.5-8.5,8.5c-4.7,0-8.5-3.8-8.4-8.4c0,0,0,0,0,0
        				c0-4.7,3.8-8.5,8.5-8.5C111.8,65.3,115.5,69.1,115.5,73.8C115.5,73.8,115.5,73.8,115.5,73.8z"
                />
                <g id="p_881.674016733653_26_">
                  <path
                    fill="#FFFFFF"
                    d="M191.5,36.4c0,8.6-7,15.5-15.6,15.6c-8.6,0-15.5-6.9-15.5-15.5c0,0,0,0,0,0c0-8.6,7-15.5,15.6-15.6
        					C184.6,20.9,191.5,27.8,191.5,36.4C191.5,36.4,191.5,36.4,191.5,36.4z"
                  />
                </g>
                <path
                  id="p_881.674016733653_24_"
                  fill="#F8A08F"
                  d="M161.5,21.3c0,2.3-1.9,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1c0,0,0,0,0,0
        				c0-2.3,1.9-4.1,4.1-4.1S161.5,19,161.5,21.3C161.5,21.3,161.5,21.3,161.5,21.3z"
                />
              </g>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 123.287 58.4974)">
                <tspan
                  x="0"
                  y="0"
                  fill="#474747"
                  font-weight="bold"
                  font-size="12px"
                >
                  {getTextSpans(text[0], true, 28, 10, "middle")}
                </tspan>
              </text>
            </g>
          </g>
          <g id="Rule_making_and_implementation">
            <g>
              <path
                id="p_881.674016733653"
                fill="#FCC0B4"
                stroke="#DE2414"
                stroke-miterlimit="10"
                d="M176.7,150.2
        			c0.1-33.1,27-60.1,60.1-60.2s59.9,26.7,59.9,59.8c0,0,0,0,0,0c-0.1,33.1-27,60.1-60.1,60.2C203.4,210.1,176.6,183.3,176.7,150.2
        			C176.7,150.2,176.7,150.2,176.7,150.2z"
              />
              <g>
                <g id="p_611.8585410466832_3_">
                  <path
                    fill="#FCDFDA"
                    d="M261.5,108.4c15.1,0,27.3,12.2,27.2,27.2c0,15.1-12.3,27.3-27.4,27.4c0,0,0,0,0,0
        					c-15.1,0-27.3-12.2-27.2-27.2C234.1,120.7,246.4,108.5,261.5,108.4C261.5,108.4,261.5,108.4,261.5,108.4z"
                  />
                </g>
                <g id="p_881.674016733653_3_">
                  <path
                    fill="#FCDFDA"
                    d="M222.4,147.4c15.1,0,27.3,12.2,27.2,27.2c0,15.1-12.3,27.3-27.4,27.4c0,0,0,0,0,0
        					c-15.1,0-27.3-12.2-27.2-27.2C195.1,159.7,207.4,147.5,222.4,147.4C222.4,147.4,222.4,147.4,222.4,147.4z"
                  />
                </g>
                <g id="p_941.5222050695544_3_">
                  <path
                    fill="#FCDFDA"
                    d="M211.3,104.3c11.2,0,20.3,9.1,20.3,20.3s-9.2,20.4-20.4,20.4c0,0,0,0,0,0c-11.2,0-20.3-9.1-20.3-20.3
        					S200.1,104.3,211.3,104.3C211.3,104.3,211.3,104.3,211.3,104.3z"
                  />
                </g>
                <g id="p_941.5222050695544_5_">
                  <path
                    fill="#FFFFFF"
                    d="M198.2,144c3.3,0,6,2.7,6,6c0,3.3-2.7,6.1-6.1,6.1c0,0,0,0,0,0c-3.3,0-6-2.7-6-6
        					C192.2,146.7,194.9,144,198.2,144C198.2,144,198.2,144,198.2,144z"
                  />
                </g>
                <path
                  id="p_941.5222050695544_8_"
                  fill="#F8A08F"
                  d="M192.8,157.6c1.7,0,3,1.3,3,3s-1.4,3-3,3c0,0,0,0,0,0c-1.7,0-3-1.3-3-3
        				C189.7,159,191.1,157.6,192.8,157.6C192.8,157.6,192.8,157.6,192.8,157.6z"
                />
                <path
                  id="p_941.5222050695544_11_"
                  fill="#F8A08F"
                  d="M234.7,113.2c1.7,0,3,1.3,3,3c0,1.7-1.4,3-3,3c0,0,0,0,0,0
        				c-1.7,0-3-1.3-3-3C231.7,114.6,233,113.2,234.7,113.2C234.7,113.2,234.7,113.2,234.7,113.2z"
                />
                <g id="p_941.5222050695544_14_">
                  <path
                    fill="#F8A08F"
                    d="M240.3,93.6c4.8,0,8.6,3.8,8.6,8.6c0,4.8-3.9,8.6-8.7,8.7c0,0,0,0,0,0c-4.8,0-8.6-3.8-8.6-8.6
        					C231.6,97.5,235.5,93.6,240.3,93.6C240.3,93.6,240.3,93.6,240.3,93.6z"
                  />
                </g>
                <g id="p_941.5222050695544_7_">
                  <path
                    fill="#FFFFFF"
                    d="M265.9,164.2c8.6,0,15.5,6.9,15.5,15.5c0,8.6-7,15.6-15.6,15.6c0,0,0,0,0,0c-8.6,0-15.5-6.9-15.5-15.5
        					C250.3,171.2,257.3,164.3,265.9,164.2C265.9,164.2,265.9,164.2,265.9,164.2z"
                  />
                </g>
              </g>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 186.4883 145.3835)">
                <tspan
                  x="50"
                  y="0"
                  fill="#474747"
                  font-weight="bold"
                  font-size="12px"
                  text-anchor="middle"
                >
                  {getTextSpans(text[1], true, 50, 10, "middle")}
                </tspan>
              </text>
            </g>
          </g>
          <g id="Learning_and_evidence">
            <g>
              <path
                id="p_611.8585410466832"
                fill="#FCC0B4"
                stroke="#DE2414"
                stroke-miterlimit="10"
                d="M3.9,150.2C4,117,30.9,90.1,64.1,90
        			s59.9,26.7,59.9,59.8c0,0,0,0,0,0c-0.1,33.1-27,60.1-60.1,60.2C30.6,210.1,3.8,183.3,3.9,150.2C3.9,150.2,3.9,150.2,3.9,150.2z"
              />
              <g>
                <g id="p_611.8585410466832_1_">
                  <path
                    fill="#FCDFDA"
                    d="M37.3,189.3c-15,0-27.1-12.1-27.1-27s12.2-27.2,27.2-27.2c0,0,0,0,0,0c15,0,27.1,12.1,27.1,27
        					S52.2,189.2,37.3,189.3C37.3,189.3,37.3,189.3,37.3,189.3z"
                  />
                </g>
                <g id="p_881.674016733653_1_">
                  <path
                    fill="#FFFFFF"
                    d="M76,150.5c-15,0-27.1-12.1-27.1-27s12.2-27.2,27.2-27.2c0,0,0,0,0,0c15,0,27.1,12.1,27.1,27
        					S91,150.5,76,150.5C76,150.5,76,150.5,76,150.5z"
                  />
                </g>
                <g id="p_941.5222050695544_1_">
                  <path
                    fill="#FCDFDA"
                    d="M87,196.6c-13,0-23.5-10.5-23.4-23.4c0-13,10.6-23.5,23.5-23.6c0,0,0,0,0,0c13,0,23.5,10.5,23.4,23.4
        					C110.5,186.1,100,196.6,87,196.6C87,196.6,87,196.6,87,196.6z"
                  />
                </g>
                <g id="p_528.3126953742086_1_">
                  <path
                    fill="#FCDFDA"
                    d="M34.4,134.7c-7.8,0-14.1-6.3-14.1-14.1s6.4-14.2,14.2-14.2c0,0,0,0,0,0c7.8,0,14.1,6.3,14.1,14.1
        					C48.6,128.3,42.3,134.7,34.4,134.7C34.4,134.7,34.4,134.7,34.4,134.7z"
                  />
                </g>
                <g id="p_881.674016733653_17_">
                  <path
                    fill="#FFFFFF"
                    d="M56.8,188c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5c0,0,0,0,0,0c0,1.9-1.6,3.5-3.5,3.5
        					C58.3,191.5,56.8,189.9,56.8,188C56.8,188,56.8,188,56.8,188z"
                  />
                </g>
                <path
                  id="p_881.674016733653_20_"
                  fill="#F8A08F"
                  d="M98.3,146.1c0-5.5,4.5-10,10-10s10,4.4,9.9,9.9c0,0,0,0,0,0
        				c0,5.5-4.5,10-10,10C102.8,156.1,98.3,151.6,98.3,146.1C98.3,146.1,98.3,146.1,98.3,146.1z"
                />
              </g>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 35.9689 145.3837)">
                <tspan
                  x="50"
                  y="0"
                  fill="#474747"
                  font-weight="bold"
                  font-size="12px"
                  text-anchor="middle"
                >
                  {getTextSpans(text[2], true, 25, 10, "middle")}
                </tspan>
              </text>
            </g>
          </g>
          <g id="Compliance">
            <g>
              <path
                id="p_941.5222050695544"
                fill="#FCC0B4"
                stroke="#DE2414"
                stroke-miterlimit="10"
                d="M90,237.1c0.1-33.1,27-60.1,60.1-60.2
        			s59.9,26.7,59.9,59.8c0,0,0,0,0,0c-0.1,33.1-27,60.1-60.1,60.2C116.7,297.1,89.9,270.3,90,237.1C90,237.2,90,237.2,90,237.1z"
              />
              <g>
                <g id="p_611.8585410466832_5_">
                  <path
                    fill="#FCDFDA"
                    d="M101.1,217.9c0-15.4,12.6-28,28-28c15.4,0,27.9,12.4,27.9,27.8c0,0,0,0,0,0c0,15.4-12.6,28-28,28
        					C113.5,245.8,101,233.3,101.1,217.9C101.1,217.9,101.1,217.9,101.1,217.9z"
                  />
                </g>
                <g id="p_881.674016733653_5_">
                  <path
                    fill="#FCDFDA"
                    d="M140.8,257.5c0-15.4,12.6-28,28-28s27.9,12.4,27.9,27.8c0,0,0,0,0,0c0,15.4-12.6,28-28,28
        					C153.2,285.4,140.7,273,140.8,257.5C140.8,257.5,140.8,257.5,140.8,257.5z"
                  />
                </g>
                <g id="p_881.674016733653_7_">
                  <path
                    fill="#FCDFDA"
                    d="M159.3,215.5c0-6.8,5.5-12.3,12.3-12.3c6.8,0,12.3,5.5,12.2,12.2c0,0,0,0,0,0c0,6.8-5.5,12.3-12.3,12.3
        					C164.8,227.8,159.3,222.3,159.3,215.5C159.3,215.5,159.3,215.5,159.3,215.5z"
                  />
                </g>
                <path
                  id="p_881.674016733653_9_"
                  fill="#F8A08F"
                  d="M182.5,227.7c0-2.7,2.2-4.8,4.9-4.9c2.7,0,4.8,2.2,4.8,4.8c0,0,0,0,0,0
        				c0,2.7-2.2,4.8-4.9,4.9C184.7,232.5,182.5,230.4,182.5,227.7C182.5,227.7,182.5,227.7,182.5,227.7z"
                />
                <g id="p_881.674016733653_11_">
                  <path
                    fill="#FCDFDA"
                    d="M106.1,265.3c0-8.6,7-15.6,15.7-15.7s15.6,6.9,15.6,15.6c0,0,0,0,0,0c0,8.6-7,15.6-15.7,15.7
        					C113.1,280.9,106.1,273.9,106.1,265.3C106.1,265.3,106.1,265.3,106.1,265.3z"
                  />
                </g>
                <g id="p_881.674016733653_13_">
                  <path
                    fill="#FFFFFF"
                    d="M136.3,280.5c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.1,1.8,4.1,4.1c0,0,0,0,0,0c0,2.3-1.9,4.2-4.2,4.2
        					C138.2,284.7,136.3,282.8,136.3,280.5C136.3,280.5,136.3,280.5,136.3,280.5z"
                  />
                </g>
                <g id="p_881.674016733653_15_">
                  <path
                    fill="#FFFFFF"
                    d="M149.8,193.1c0-5.3,4.3-9.5,9.5-9.5c5.3,0,9.5,4.2,9.5,9.5c0,0,0,0,0,0c0,5.3-4.3,9.5-9.5,9.5
        					C154.1,202.6,149.8,198.4,149.8,193.1C149.8,193.1,149.8,193.1,149.8,193.1z"
                  />
                </g>
              </g>
            </g>
            <g>
              <text transform="matrix(1 0 0 1 114.9146 240.3738)">
                <tspan
                  x="35"
                  y="0"
                  fill="#474747"
                  font-weight="bold"
                  font-size="12px"
                  text-anchor="middle"
                >
                  {getTextSpans(text[3], true, 35, 0, "middle")}
                </tspan>
              </text>
            </g>
          </g>
          <g id="VIz_2_and_3"></g>
          <g id="Test"></g>
          <g id="Layer_1"></g>
        </svg>
      </div>
    </div>
  );
};

export default ClusterViz;
